<template>
  <app-layout title="Payment Status">
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
      <br />

      <!-- progressbar start from here -->
      <progressstep step="6"></progressstep>
      <!-- progresbar end here -->

      <br /><br /><br />
      <div class="text-center place-content-center">
        <img
          :src="'/imgs/greentick.png'"
          alt="Payment Success"
          class="inline"
          width="230"
        />
        <br />
        <h4 class="text-center">Congratulations!!</h4>
        <h6 class="text-center">
          You have successfully subscribed for {{ productName }}
        </h6>

        <div class="flex">
          <div class="flex-auto">
            Do you want to Assign License to yourself ? 
            <input type="checkbox" id="checkbox" v-model="checked" />
          </div>
        
        </div>

        <h6>Click below to deploy the product</h6>
        <br />
        <jet-button
          @click="deployProductModule()"
          class="
            text-white text-lg
            hover:no-underline
            rounded
            bg-gray-800
            ml-2
            pl-4
            pr-4
            pt-2
            pb-2
            cursor-pointer
          "
          >Deploy</jet-button
        >
      </div>
    </div>
  </app-layout>
</template>
<style>
.noselect {
  -webkit-touch-callout: none;
  /* iOS Safari */
  -webkit-user-select: none;
  /* Safari */
  -khtml-user-select: none;
  /* Konqueror HTML */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* Internet Explorer/Edge */
  user-select: none;
  /* Non-prefixed version, currently supported by Chrome and Opera */
}

.img-company {
  width: 50px;
  height: 50px;
}

.no-decoration {
  text-decoration: none;
}

.no-decoration:hover {
  text-decoration: none;
}

.btn-submit {
  background-color: var(--blue);
}
</style>

<script>
import Progressstep from "../Views/Components/Progressbar.vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import Welcome from "@/Jetstream/Welcome.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";

export default {
  props: {
    organisationHost: String,
    productId: String,
    organisationId: String,
    subscriptionPlanId: String,
    subscriptinPriceId: String,
    productName: String,
    subscriptionId: String,
  },

  components: {
    Progressstep,
    AppLayout,
    Welcome,
    PageTitle,
    JetNavLink,
  },
  data() {
    return {
     checked: true
    };
  },
  methods: {
    deployProductModule() {
      var data = {
        productId: this.productId,
        organisationHost: this.organisationHost,
        organisationId: this.organisationId,
        subscriptionPlanId: this.subscriptionPlanId,
        subscriptinPriceId: this.subscriptinPriceId,
        subscriptionId: this.subscriptionId,
        assignRole :this.checked
      };


 //     this.$inertia.post(route("marketplaces.deployproductmodule"), data);
    },
  },
  mounted() {},
};
</script>